var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductActiveICon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.6667 10.833V4.99967C16.6667 4.0792 15.9205 3.33301 15 3.33301H5.00004C4.07957 3.33301 3.33337 4.0792 3.33337 4.99967V10.833M16.6667 10.833V14.9997C16.6667 15.9201 15.9205 16.6663 15 16.6663H5.00004C4.07957 16.6663 3.33337 15.9201 3.33337 14.9997V10.833M16.6667 10.833H14.5119C14.2909 10.833 14.0789 10.9208 13.9226 11.0771L11.9108 13.0889C11.7545 13.2452 11.5425 13.333 11.3215 13.333H8.67855C8.45754 13.333 8.24558 13.2452 8.0893 13.0889L6.07745 11.0771C5.92117 10.9208 5.70921 10.833 5.4882 10.833H3.33337",
    stroke: "#4F46E5",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductActiveICon);
export default __webpack_public_path__ + "static/media/productActiveICon.3cdab9320883bee4f164ff39f665e1c5.svg";
export { ForwardRef as ReactComponent };